<template>
  <div :class="$style.home_notice_edit_bg">
    <div :class="$style.home_notice_edit_main">
      <div :class="$style.home_notice_edit">
        <app-prev-button
          margin="10px 10px 0px"
          @click="backButtonAction(prevRoute)"
        />
        <div :class="$style.notice_edit_wrap">
          <div :class="$style.notice_border">
            <p :class="$style.title_text">投稿の通知設定</p>
            <div :class="$style.text_button_area">
              <p :class="$style.switch_text_area">コメント通知</p>
              <base-button
                :class="$style.switch_button_area"
                rounded="corner"
                width="85px"
                height="30px"
                @click.prevent="toggleCommentNoticeFlg"
                >{{
                  this.comment_notification_flg ? 'OFFにする' : 'ONにする'
                }}</base-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.home_notice_edit_footer">
      <div :class="$style.confirm_button_wrap">
        <base-button bordered rounded="rounded" width="120px" @click.prevent="backButtonAction(prevRoute)"
          >キャンセル</base-button
        >
        <base-button
          rounded="rounded"
          width="120px"
          @click.prevent="updateNoticeSetting"
          >設定完了</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton/BaseButton'
import AppPrevButton from '@/components/app/AppPrevButton/AppPrevButton'
export default {
  name: 'AdminNoticeEdit',
  components: {
    BaseButton,
    AppPrevButton,
  },
  props: {
    team_id: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    this.emitPageUpdated()
    this.fetchNoticeSetting()
    console.log('emitPageUpdated')
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from && from.name) {
        if (from.name == 'HomeNoticeEdit') {
          vm.prevRoute = { name: 'HomeHome' }
        } else {
          vm.prevRoute = from
        }
      } else {
        vm.prevRoute = '__history_back'
      }
    })
  },
  data() {
    return {
      prevRoute: '',
      comment_notification_flg: false,
    }
  },
  methods: {
    toggleCommentNoticeFlg: function () {
      this.comment_notification_flg = !this.comment_notification_flg
    },
    fetchNoticeSetting() {
      this.$axios
        .get('/api/' + this.$constants.API_VERSION + '/user/notification/post_setting', {params: { team_id: this.team_id }})
        .then((res) => {
          this.comment_notification_flg = res.data.value.comment_notification_flg
        })
    },
    async updateNoticeSetting() {
      var is_updated_setting = false
      await this.$axios
        .post('/api/' + this.$constants.API_VERSION + '/user/notification/post_setting', {
          team_id: this.team_id,
          comment_notification_flg: this.comment_notification_flg,
        })
        .then((res) => {
          if (res.data.status == 'success') {
            is_updated_setting = true
          }
        })

      if (is_updated_setting) {
        alert('設定を変更しました')
      } else {
        alert('設定を変更できませんでした。時間をおいて再度お試しください。')
      }
    },
    emitPageUpdated() {
      this.$router.app.$emit('page-updated', {
        pageTitle: '通知設定',
        showSetting: false,
        back: this.prevRoute,
        bgColor: 'white',
        headerColor: 'yellow',
        showTabbar: false,
        showFooter: true,
      })
    },
    scrollToTop: function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    backButtonAction(back) {
      if (back === '__history_back') {
        this.$router.go(-1)
      } else {
        this.$router.push(back, () => {})
      }
    },
  },
}
</script>

<style lang="scss" module>
.home_notice_edit_bg {
  width: 100%;
  background-color: $backGround;
}

.home_notice_edit {
  @include pc() {
    // width: 980px;//TODO:
    width: 400px;
    margin: 0 auto;
    background-color: $keyWhite;
  }

  @include mobile() {
    width: 100%;
    background-color: $backGround;
    padding-bottom: 84px;
  }

  &_content {
    width: 375px;
    margin: 0 auto;
    margin-top: 12px;
    @include mobile() {
      margin-top: 10px;
    }
  }
}

.home_notice_edit_main {
  display: block;
  width: 100%;
  background-color: $keyWhite;

  .notice_edit_wrap {
    display: flex;
    flex-direction: column;
    align-items: left;

    .notice_border {
      box-sizing: border-box;
      border-bottom: 1px $borderLiteGray solid;
    }

    .normal_button_area {
      margin-bottom: 20px;
      margin-top: 17px;
      margin-left: 40px;
    }

    .notice_mail_button_area {
      margin-bottom: 20px;
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .text_button_area {
      display: flex;
      justify-content: left;

      .switch_text_area {
        font-size: 12px;
        width: 240px;
        margin-bottom: 0;
        margin-top: 10px;
        margin-left: 30px;
      }
      .switch_button_area {
        margin-bottom: 10px;
        margin-top: 0px;
        margin-left: 30px;
        font-size: 9px;
      }
    }

    .title_text {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
      margin-top: 20px;
      margin-left: 30px;
    }
    .normal_text {
      font-size: 12px;
      margin-bottom: 0;
      margin-top: 3px;
      margin-left: 30px;
    }
  }
}

.home_notice_edit_footer {
  display: block;
  position: sticky;
  width: 100%;
  height: 85px;
  bottom: 0;
  background-color: $keyYellow;

  @include mobile() {
    background: $keyYellow;
    box-sizing: border-box;
    border-top: 1px solid $borderLiteGray;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 12;
  }

  .confirm_button_wrap {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;

    & > :first-child {
      margin-right: 20px;
    }
  }
}
</style>
